/**
 *  @author:        Cloud for Good
 *  @description:   Builds the main.js file including necessary components.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good       N/A                Initial creation
*/

window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/giftOptions'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/skipNav'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
